import { useState } from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';
import { useNavigate } from 'react-router';

/**
 * The header search box (FRD-CORE-038): Enter opens the results page for the words typed. Results
 * come from every module the user may see; the page itself states what was searched, and explains
 * a query too short to search rather than ignoring the key press.
 */
export function GlobalSearchBox({ compact }: { compact: boolean }) {
  const navigate = useNavigate();
  const [text, setText] = useState('');
  return (
    <TextField
      size="small"
      placeholder="Search records"
      value={text}
      onChange={(e) => {
        setText(e.target.value);
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter' && text.trim().length > 0) {
          void navigate(`/search?q=${encodeURIComponent(text.trim())}`);
        }
        if (e.key === 'Escape') setText('');
      }}
      slotProps={{
        htmlInput: {
          'aria-label': 'Search records',
          maxLength: 100,
          enterKeyHint: 'search',
          type: 'search',
        },
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" />
            </InputAdornment>
          ),
        },
      }}
      sx={{ width: compact ? 150 : 260 }}
    />
  );
}
